import { useAppSelector } from "@hooks/store"
import { createDefaultCharge } from "../services/POST/createDefaultCharge"
import { getChargeDetail } from "../services/GET/getChargeDetail"
import { useCallback } from "react"
import verifyResponse from "@thelpers/verifyResponse"
import { getChargeDebtors } from "../services/GET/getChargeDebtors"
import { updateCharge } from "../services/PUT/updateCharge"

export const useNewEditTemplateCollectionServices = () => {

    const { idToken, currentRol } = useAppSelector(state => state.auth)

    const createDefaultChargeService = useCallback(async ({ setLoading }) => {
        setLoading?.(true)
        try {
            const res = await createDefaultCharge({ token: idToken, company_id: currentRol })
            const status = verifyResponse({ dataResponse: res.data, statusResponse: res.data.status })
            if (!status) throw new Error('Error al crear cobro por defecto')
            return res.data.data

        } catch (error) {
            console.error(error)
            return error
        }
        finally {
            setLoading?.(false)
        }

    }, [currentRol, idToken])

    const getChargeDetailService = useCallback(async ({ setLoading, charge_id }) => {
        setLoading?.(true)
        try {
            const res = await getChargeDetail({ token: idToken, charge_id })
            const status = verifyResponse({ dataResponse: res.data, statusResponse: res.data.status })
            if (!status) throw new Error('Error al obtener cobro por defecto')
            return res.data.data

        } catch (error) {
            console.error(error)
            return error
        }
        finally {
            setLoading?.(false)
        }

    }, [idToken])

    const getChargeDebtorsService = useCallback(async ({ setLoading, charge_id }) => {
        setLoading?.(true)
        try {
            const res = await getChargeDebtors({ token: idToken, charge_id })
            const status = verifyResponse({ dataResponse: res.data, statusResponse: res.data.status })
            if (!status) throw new Error('Error al obtener los pagantes de la plantilla')
            return res.data.data

        } catch (error) {
            console.error(error)
            return error
        }
        finally {
            setLoading?.(false)
        }

    }, [idToken])

    const updateChargeService = useCallback(async ({ setLoading, jsonData }) => {
        setLoading?.(true)
        try {
            const res = await updateCharge({ token: idToken, jsonData })
            const status = verifyResponse({ dataResponse: res.data, statusResponse: res.data.status, message: 'Plantilla de cobro actualizada' })
            if (!status) throw new Error('Error al actualizar cobro')
            return res.data.data

        } catch (error) {
            console.error(error)
            return error
        }
        finally {
            setLoading?.(false)
        }

    }, [idToken])

    return {
        createDefaultChargeService,
        getChargeDetailService,
        getChargeDebtorsService,
        updateChargeService
    }
}